import { createTransform } from "redux-persist";

const SetTransform = createTransform(
  // transform state on its way to being serialized and persisted.
  // eslint-disable-next-line
  (inboundState: any, key) => {
    // convert mySet to an Array.
    return { ...inboundState, mySet: [...inboundState.mySet] };
  },
  // transform state being rehydrated
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (outboundState, key) => {
    // convert mySet back to a Set.
    return { ...outboundState, mySet: new Set(outboundState.mySet) };
  },
  // define which reducers this transform gets called for.
  { whitelist: ["someReducer"] }
);

export default SetTransform;
